module.exports = __webpack_public_path__ + "media/pl_pl_s1_Bozena.1ef05fd4.mp3";